import React, { Component } from 'react'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import ellipsis from 'text-ellipsis'
import Carousel from 'aria-viewer/tour/components/carousels/carousel'
import Icon from 'aria-viewer/tour/components/icon'
import pure from 'recompose/pure'

class RegistrationCarousel extends Component {
    constructor(props) {
        super(props)

        this.state = {
            slideIndex: 0,
            hasMoved: false,
            width: 0,
            visible: true,
        }
        this.onSlideMoveEnd = this.onSlideMoveEnd.bind(this)
    }
    init(props) {
        if (!this.state.hasMoved) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.setState({ slideIndex: 1 })
            }, 5000)
        }

        if (this.state.width != props.width) {
            this.setState({
                width: props.width,
                visible: false,
            })

            clearTimeout(this.showCarouselTimeout)
            this.showCarouselTimeout = setTimeout(() => {
                this.setState({ visible: true })
            })
        }
    }
    componentDidMount() {
        this.init(this.props)
    }
    componentWillReceiveProps(props) {
        this.init(props)
    }
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }
    onSlideMoveEnd(index) {
        if ((index > 0) & !this.state.hasMoved) {
            this.setState({ hasMoved: true })
            clearTimeout(this.timeout)
        }
        this.setState({ slideIndex: index })
    }
    render() {
        const { formInfo } = this.props
        const { width } = this.state
        const characterCount = Math.floor(width * 0.2)
        const scale = width / 360
        const slides = formInfo.map(item => {
            return {
                style: {
                    width: scale * 164,
                    height: scale * 164,
                },
            }
        })
        const carouselHeight = width * 0.78

        return this.state.visible ? (
            <Carousel
                style={{
                    position: 'relative',
                    margin: '15px auto 0',
                    width,
                    overflow: 'hidden',
                }}
                innerWidth={width}
                outerWidth={width}
                height={carouselHeight}
                dots={true}
                dotStyle={{
                    size: 10,
                    activeColor: styleguide.colors.grey_5,
                    inactiveColor: styleguide.colors.grey_6,
                    border: 'none',
                    bottom: '0',
                }}
                discrete={true}
                infinite={false}
                onSlideMoveEnd={this.onSlideMoveEnd}
                index={this.state.slideIndex}
                items={slides.map((item, index) => {
                    return {
                        Tag: RegistrationCarouselItem,
                        props: {
                            icon: formInfo[index].icon,
                            iconStyle: Object.assign({}, item.style, { margin: 'auto' }),
                            contentStyle: {
                                position: 'absolute',
                                top: '65%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '90%',
                                textAlign: 'center',
                                maxHeight: '58px',
                                overflow: 'hidden',
                                fontSize: 16,
                            },
                            children: ellipsis(formInfo[index].label, characterCount),
                        },
                    }
                })}
            />
        ) : null
    }
}

const RegistrationCarouselItem = pure(function RegistrationCarouselItem({ icon, iconStyle, contentStyle, children }) {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                textAlign: 'center',
            }}
        >
            <Icon icon={icon} style={iconStyle} />
            <div style={contentStyle}>{children}</div>
        </div>
    )
})

export default RegistrationCarousel
